import AuditorLayout from "@/components/AuditorLayout";
import AuditRoom from "@/components/AuditRoom";

const AuditorRoom = () => (
  <AuditorLayout>
    <div className="mb-6">
      <h1 className="text-2xl font-display font-semibold text-slate-900">Audit Room</h1>
      <p className="text-sm text-slate-500 mt-1">
        Direct, recorded channel with the Velocity Offshore team. Ask questions, request evidence,
        and exchange controlled documents in one place.
      </p>
    </div>
    <AuditRoom theme="light" />
  </AuditorLayout>
);

export default AuditorRoom;
